export default "__VITE_ASSET__BHFnLYTx__"